import { InputRequestValue } from "@/components/active-session/types";
import { SessionEventObservable } from "@/store/sessions/SessionEventObservable";

export const getNextInputRequestValue = (
  events: SessionEventObservable[]
): InputRequestValue | undefined => {
  let openRequest: InputRequestValue | undefined = undefined;

  const inputRequestEvents = events.filter(event => event.kind === "INPUT_REQUESTED");

  for (const inputRequestEvent of inputRequestEvents) {
    if (
      events.some(e => {
        if (e.kind === "INPUT_PROVIDED") {
          return e.eventValue.request_id === inputRequestEvent.eventValue.id;
        } else {
          return false;
        }
      }) === false
    ) {
      openRequest = inputRequestEvent.eventValue as InputRequestValue;
      break;
    }
  }

  return openRequest;
};
